import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import moment from 'moment';
import {reverseShortDate} from '../../common/constants/datesFormat';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'requestsList': [],
  'directory': [],
};

export const usersList = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_USERS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_USERS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data.map((x) => {
        return x.creationDate ? {...x, 'creationDate': moment(x.creationDate).format(reverseShortDate)} : {...x};
      }),
    }),
    [ActionTypes.FETCHED_USERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.FETCHING_USERS_REQUESTS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_USERS_REQUESTS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'requestsList': action.response.data,
    }),
    [ActionTypes.FETCHED_USERS_REQUESTS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'requestsList': [],
    }),
    [ActionTypes.GET_USERS_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_USERS_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.GET_USERS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.FETCHING_USERS_FROM_DIRECTORY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_USERS_FROM_DIRECTORY]: (state, action) => ({
      ...state,
      'loading': false,
      'directory': action.response.data,
    }),
    [ActionTypes.FETCHED_USERS_FROM_DIRECTORY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'directory': [],
    }),
    [ActionTypes.DELETING_USER_FROM_REQUESTS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETED_USER_FROM_REQUESTS]: (state, action) => ({
      ...state,
      'loading': false,
      'requestsList': action.response.data,
    }),
    [ActionTypes.DELETED_USER_FROM_REQUESTS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CLEAR_USER_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
  })(state, action);
};

